// 新版视图列表页组件api
import axios from '@/config/httpConfig'

// 自定义按钮
export function openCall(data) {
  return axios.post('/openCall/common', data)
}